var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetCoinOutlinedWarn = function SvgZetCoinOutlinedWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FA8E2B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.19c3.75 0 6.808 3.05 6.808 6.81A6.81 6.81 0 0 1 9 15.806c-3.758 0-6.808-3.058-6.808-6.808S5.25 2.191 9 2.191M9 .858C4.508.857.858 4.507.858 9A8.143 8.143 0 0 0 9 17.141c4.5 0 8.142-3.642 8.142-8.142S13.492.857 9 .857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.124 6.975H9.705l.568 1.246h1.307v2.803h1.248V8.22h1.296zM7.444 6.975H3.876V8.22h1.72l-1.72 1.556v1.247h3.568V9.777h-1.72l1.72-1.556zM10.69 9.777H8.873v-.215h1.718l-.325-.701-.197-.425H8.872V8.22h1.085L9.39 6.975h-1.6600000000000001v4.0489999999999995h3.5410000000000004z"
  }))));
};
export default SvgZetCoinOutlinedWarn;